const EmailIcon = () => (
  <svg viewBox="0 0 24 24" height={20} fill="currentColor">
    <path
      d="M19 4a3 3 0 013 3v10a3 3 0 01-3 3H5a3 3 0 01-3-3V7a3 3 0 013-3h14zm1 3.014l-6.37 4.123a3 3 0 01-3.26 0L4 7.014V17a1 1 0 001 1h14a1 1 0 001-1V7.014zM17.885 6H6.114l5.343 3.457a1 1 0 00.973.064l.113-.064L17.885 6z"
      fillRule="evenodd"
    />
  </svg>
);

export default EmailIcon; 